"use client";
import { SessionProvider } from "next-auth/react";

export default function SessionLocalProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  return <SessionProvider>{children}</SessionProvider>;
}
